import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import saveAs from 'file-saver';
import { forkJoin, Observable } from 'rxjs';
import {
  MSSPOperatorWorkshop,
  DocumentsType
} from '../../../../models/_enum-collections';
import { ApiResponse } from '../../../../models/api-response.model';
import { CustomerAcknowledgement } from '../../../../models/customer-ack.model';
import {
  DocumentDeclineReason,
  DocumentReviewModel
} from '../../../../models/document-review.model';
import {
  DocumentTypes,
  DocumentTypesString
} from '../../../../models/document-types.model';
import { EngagementPreviewInput } from '../../../../models/engagement-preview-input.model';
import { EngagementSurvey } from '../../../../models/engagement-survey.model';
import { InvoiceRejectReason } from '../../../../models/invoice-reject-reason';
import { NotesModel } from '../../../../models/notes.model';
import { PoeDocStatus } from '../../../../models/poe-doc-status.model';
import {
  SpecialInvestmentPoeDocument,
  PoeDocument
} from '../../../../models/poe-document.model';
import {
  UpdatePOEInformationRequest,
  UpdatePOEInformationRequestDocument
} from '../../../../models/poe-information-survey.model';
import { PoeinvoiceStatus } from '../../../../models/poe-invoice-status.model';
import {
  PoeNominationDocuments,
  PoeNominationDocument
} from '../../../../models/poe-nomination-documents.model';
import { PoeStatus } from '../../../../models/poe-status.model';
import { PoeSurveyResponse } from '../../../../models/poe-survey-response.model';
import { PoeSurveyStatus } from '../../../../models/poe-survey-status.model';
import {
  UpdateCustomerAckDocument,
  PreviewDocumentTypes
} from '../../../../models/update-customer-ack-document.model';
import { AppConstants } from '../../../common/app-constants';
import { CommonService } from '../../../common/common.service';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { EngagementPreviewComponent } from '../../../preview/engagement-preview/engagement-preview.component';
import { DashboardService } from '../../../services/dashboard.service';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-poe-submission-special-investments',
  templateUrl: './poe-submission-special-investments.component.html',
  styleUrls: ['./poe-submission-special-investments.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EngagementPreviewComponent]
})
export class PoeSubmissionSpecialInvestmentsComponent implements OnInit {
  @Input() engagementId!: number;
  @Input() programType!: number;
  @Output() refreshPartnerInput = new EventEmitter();
  @Output() closePreviewModal = new EventEmitter();
  historyTableRow!: number;

  engagementPreviewInput = {} as EngagementPreviewInput;
  customerAcknowledgement = 'Customer Acknowledgement';
  docType!: number;
  loadUploadDialog = false;
  isCusSurveyResponse = false;
  isPoeInvoicePreview = false;
  canShowPreviewModel = false;
  isReadonlyPOESurvey = true;
  btnNavPoeSurvey = false;
  downloadSpin: boolean[] = [];
  msgsPoeSurvey!: any[];
  invoiceDocument = 'Invoice POE Special Investments';

  customerSurveyRejectionReason!: string;
  fileNamePartCust!: string;
  uname!: string;
  formPOESurvey!: FormGroup;
  formEngagementDetails!: FormGroup;
  formPOEInformation!: FormGroup;
  formEngagement!: FormGroup;
  maxYearDate!: Date;
  datePipe = new DatePipe('en-US');
  notes!: NotesModel[];
  poeStatus!: PoeStatus[];
  PoeDocStatus!: PoeDocStatus[];
  PoeInvoiceStatus!: PoeinvoiceStatus[];
  partnerPOESurveyStatus!: PoeSurveyStatus[];
  cusPoeSurveyResponse!: PoeSurveyResponse[];
  cusSurveyRejectionReason!: DocumentDeclineReason[];
  customer: CustomerAcknowledgement[] = [];
  partner: CustomerAcknowledgement[] = [];
  updatePoeInformationRequest!: UpdatePOEInformationRequest;
  apires!: ApiResponse;
  engagementSurveys!: EngagementSurvey[];
  poeNominationDocuments!: PoeNominationDocuments;
  poeNominationRequiredDocuments!: PoeNominationDocument[];
  poeDocumentRejectionReasons!: InvoiceRejectReason[];
  poeInvoiceRejectionReasons!: InvoiceRejectReason[];
  rfpAwardLetterRejectionReasons!: InvoiceRejectReason[];
  rfpDescriptionRejectionReasons!: InvoiceRejectReason[];
  sowDocRejectionReasons!: InvoiceRejectReason[];
  customerPOESurveyRejectionReasons: any;
  customerSurveryId!: number;
  customerSurveyFilePath!: string;
  deliveryName!: string;
  rpfShow = false;
  // eslint-disable-next-line no-empty-pattern
  filesUpload: any = ([] = []);
  fileUploadSpinners: boolean[] = [];
  transactionSpin!: boolean;
  uploadUrl!: string;
  loadingCount = 0;
  customerAck!: CustomerAcknowledgement[];
  umsgs: any[] = [];
  submitAck!: UpdateCustomerAckDocument;
  storeCustAckFile!: CustomerAcknowledgement;
  poeDocMaximumFiles = 1;

  @ViewChild('fileInputUpload', { static: true }) myfileInput!: ElementRef;

  constructor(
    private osmEdit: OsmosisEditService,
    private ds: DashboardService,
    private settingsServices: SettingsService,
    private commonService: CommonService,
    private http: HttpClient,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.historyTableRow = AppConstants.historyTableRow;
    forkJoin([
      this.getPOESurveyStatus(),
      this.getPoeDocumentStatus(),
      this.getPoeInvoiceStatusDropDown()
    ]).subscribe(([surveysStatuses, documentStatuses, invoiceStatuses]) => {
      this.partnerPOESurveyStatus = surveysStatuses;
      this.PoeDocStatus = documentStatuses;
      this.PoeInvoiceStatus = invoiceStatuses;
      this.getPoeDocumentsForEngagement();
    });

    this.onFormGroup();
    this.getSurveysForEngagement();

    this.getPoeStatus();
    this.getDetails(this.engagementId);
    this.getSurveyResponseFile(this.engagementId);
    this.getCustomerAckFile(this.engagementId);
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formPOESurvey = this.formBuilder.group({
      PoeStatus1: [''],
      poeDocumentSubmittedDate: [''],
      pOECompletionDate: [''],
      customerPOESurveyDate: [''],
      customerPOESurveyStatus: [''],
      partnerPOESurveyDate: [''],
      partnerPOESurveyStatus: [''],
      poeDOCstatusCn: [''],
      poeInvoicestatus: [''],
      poeRFPAwardLetterCtrl: [''],
      poeRFPDescriptionCtrl: [''],
      poeSecurityOfWork: [''],
      poeDocs: [],
      poeInvoiceDocId: '',
      customerSurveyName: [''],
      customertype: [''],
      customerSurveyCreatedDate: [''],
      partnerSurveyName: [''],
      partnerType: [''],
      partnerSurveyCreatedDate: [''],
      poeDocumentRejectionReasonsCtrl: [''],
      poeInvoiceRejectionReasonsCtrl: [''],
      rfpAwardLetterRejectionReasonsCtrl: [''],
      rfpDescriptionRejectionReasonsCtrl: [''],
      customerPOESurveyRejectionReasonsCtrl: [''],
      sowDocRejectionReasonsCtrl: ['']
    });
    this.formPOESurvey.disable();

    this.formEngagementDetails = this.formBuilder.group({
      engagementKey: [''],
      engagementName: [''],
      requestDate: [''],
      pMOPartnerName: [''],
      enagementTaskOwner: [''],
      enagementPMOTenantName: [''],
      enagementNextSteps: [''],
      enagementType: [''],
      engagementRequestID: [''],
      enagementStatus: ['']
    });

    this.formPOEInformation = this.formBuilder.group({
      scheduledActivityDate: [''],
      expectedPOEDate: [''],
      expectedPaymentMonth: [''],
      confidenceHighMediumLowReceived: [''],
      workshopCompletionDate: [''],
      workshopTypeCompleted: [''],
      tWACustomerSuccessSolutionPlanDateReceived: [''],
      tWAReportandRecommendationsreportDateReceived: [''],
      customerPostassessmentSurveyDateReceived: [''],
      engagementCompletionDate: [''],
      sWSecurityStrategyReportDateReceived: [''],
      partnerDeliveryContact: [''],
      partnerDeliveryContactEmail: [''],
      customerContactName: [''],
      customerContactEmail: [''],
      mSInvoiceNumber: [''],
      mSInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      partnerPaymentProfileStatus: [''],
      supplierID: [''],
      payeeID: [''],
      payeeName: [''],
      agreement: [''],
      submittedDate: [''],
      milestoneOneCompletedDate: [''],
      partnerStatementSentDate: [''],
      statementNumber: ['']
    });
  }

  get canShowCustomerSurveyRejection(): boolean {
    return (
      this.formPOESurvey.controls['customerPOESurveyStatus'] &&
      this.formPOESurvey.controls['customerPOESurveyStatus'].value &&
      this.formPOESurvey.controls['customerPOESurveyStatus'].value
        .poeSurveyStatusName == 'Rejected'
    );
  }

  getRejectionReasons(documentRejectionReasons: any[]): string {
    this.customerSurveyRejectionReason = '';
    if (documentRejectionReasons != null) {
      this.customerSurveyRejectionReason = documentRejectionReasons
        .map(s => s.reason)
        .join(', ');
    }
    return this.customerSurveyRejectionReason;
  }

  getDetails(id: number) {
    this.osmEdit.getFactDataByRequestDetailsById(id).subscribe(result => {
      const datePipe = new DatePipe('en-US');
      const poecompletionDate = datePipe.transform(
        result.poeCompletionDate,
        'MM/dd/yyyy'
      );
      const poeDocumentSubmittedDate = datePipe.transform(
        result.poeDocumentSubmittedDate,
        'MM/dd/yyyy'
      );
      const customerPOESurveyDate = datePipe.transform(
        result.customerPOESurveyDate,
        'MM/dd/yyyy'
      );
      this.formPOESurvey.patchValue({
        pOECompletionDate: poecompletionDate,
        poeDocumentSubmittedDate: poeDocumentSubmittedDate,
        customerPOESurveyDate: customerPOESurveyDate
      });
      this.formPOESurvey.controls['customerPOESurveyStatus'].setValue({
        poeSurveyStatusId: result.customerPOESurveyStatusId,
        poeSurveyStatusName: result.customerPOESurveyStatus
      });

      this.formPOESurvey.controls['partnerPOESurveyStatus'].setValue({
        poeSurveyStatusId: result.partnerPOESurveyStatusId,
        poeSurveyStatusName: result.partnerPOESurveyStatus
      });

      this.formPOESurvey.controls['PoeStatus1'].setValue({
        poeStatusId: result.poeStatusId,
        poeStatusName: result.poeStatusName
      });

      this.customerSurveryId = result.customerSurveyId || 0;
      this.deliveryName = result.deliveryName || '';

      if (
        this.deliveryName == MSSPOperatorWorkshop.MSSP_SecurityRFP ||
        this.deliveryName == MSSPOperatorWorkshop.Operator_SecurityRFP
      ) {
        this.rpfShow = true;
      } else {
        this.rpfShow = false;
      }

      this.customerSurveyFilePath =
        result['customerAcknowledmentFileURLBlobStorage'];
    });
  }

  get isOperatorSecurityRFP() {
    return this.deliveryName == MSSPOperatorWorkshop.Operator_SecurityRFP
      ? true
      : false;
  }

  get isDealAssociation() {
    return this.deliveryName == MSSPOperatorWorkshop.DealAssociation
      ? true
      : false;
  }
  getConvertedStatusName(statusText: string) {
    return statusText == 'Submitted' ? 'In Review' : statusText;
  }

  getPoeDocumentsForEngagement() {
    this.osmEdit
      .getPOEDocumentsForEngagementDetail(this.engagementId)
      .subscribe(response => {
        this.poeNominationDocuments = response;
        this.poeNominationRequiredDocuments =
          this.filterRequiredDocuments(response);
        this.poeNominationRequiredDocuments.forEach(document => {
          const statusText: string = this.getConvertedStatusName(
            document.status
          );
          const status = this.PoeDocStatus.find(
            s => s.poeDocStatusName == statusText
          );
          const statusId = status ? status.poeDocStatusId : null;
          const control = this.getPoeDocumentStatusFormControl(
            document.documentId
          );
          if (control != null) {
            control.setValue({
              poeDocStatusId: statusId,
              poeDocStatusName: statusText
            });
          }
          if (document['reasons']) {
            const rejectionReasonControl =
              this.getPoeDocumentRejectReasonFormControl(document.documentId);

            const reasons = document['reasons'].map(
              (reason: { documentType: any; reason: any; reasonId: any }) => {
                return {
                  documentType: reason.documentType,
                  reason: reason.reason,
                  reasonID: reason.reasonId
                };
              }
            );

            if (rejectionReasonControl) {
              rejectionReasonControl.setValue(reasons);
            }
          }
        });
        const documentIds = this.poeNominationRequiredDocuments.map(
          document => document.documentId
        );
        this.getRejectionReasonDropDown(documentIds).subscribe(result => {
          const rejectionReasons: any = [];

          result.forEach(document => {
            if (document.length > 0) {
              const reason = {
                documentType: document[0].documentType,
                reason: document
              };
              rejectionReasons.push(reason);
            }
          });

          this.poeDocumentRejectionReasons = rejectionReasons.find(
            (r: { documentType: DocumentsType }) =>
              r.documentType == DocumentsType.POEDocument
          )?.reason;
          this.poeInvoiceRejectionReasons = rejectionReasons.find(
            (r: { documentType: DocumentsType }) =>
              r.documentType == DocumentsType.POEInvoice
          )?.reason;
          this.rfpAwardLetterRejectionReasons = rejectionReasons.find(
            (r: { documentType: DocumentsType }) =>
              r.documentType == DocumentsType.RequestForProposalAwardLetter
          )?.reason;
          this.rfpDescriptionRejectionReasons = rejectionReasons.find(
            (r: { documentType: DocumentsType }) =>
              r.documentType == DocumentsType.RequestForProposalDescription
          )?.reason;
          this.sowDocRejectionReasons = rejectionReasons.find(
            (r: { documentType: DocumentsType }) =>
              r.documentType == DocumentsType.SOW
          )?.reason;
        });
      });
  }

  getRejectionReasonDropDown(documentIds: number[]) {
    const rejectionReasons: Observable<InvoiceRejectReason[]>[] = [];

    documentIds.forEach(id => {
      const documnetType: DocumentsType = id;
      rejectionReasons.push(
        this.osmEdit.getInvoiceRejectionReasonDropDown(documnetType)
      );
    });
    return forkJoin(rejectionReasons);
  }

  getPoeDocumentStatusFormControl(
    documentType: DocumentTypes
  ): AbstractControl | null {
    switch (documentType) {
      case DocumentTypes.POEInvoice:
        return this.formPOESurvey.controls['poeInvoicestatus'];
      case DocumentTypes.POEDocument:
        return this.formPOESurvey.controls['poeDOCstatusCn'];
      case DocumentTypes.RequestForProposalAwardLetter:
        return this.formPOESurvey.controls['poeRFPAwardLetterCtrl'];
      case DocumentTypes.RequestForProposalDescription:
        return this.formPOESurvey.controls['poeRFPDescriptionCtrl'];
      case DocumentTypes.SOW:
        return this.formPOESurvey.controls['poeSecurityOfWork'];
    }
    return null;
  }

  getPoeDocumentRejectReasonFormControl(
    documentType: DocumentTypes
  ): AbstractControl | null {
    switch (documentType) {
      case DocumentTypes.POEInvoice:
        return this.formPOESurvey.controls['poeInvoiceRejectionReasonsCtrl'];
      case DocumentTypes.POEDocument:
        return this.formPOESurvey.controls['poeDocumentRejectionReasonsCtrl'];
      case DocumentTypes.RequestForProposalAwardLetter:
        return this.formPOESurvey.controls[
          'rfpAwardLetterRejectionReasonsCtrl'
        ];
      case DocumentTypes.RequestForProposalDescription:
        return this.formPOESurvey.controls[
          'rfpDescriptionRejectionReasonsCtrl'
        ];
      case DocumentTypes.SOW:
        return this.formPOESurvey.controls['sowDocRejectionReasonsCtrl'];
    }
    return null;
  }

  onPOEDocumentStatusChange(id: number, value: any): void {
    const currentArr = this.formPOESurvey.controls['poeDocs'].value;
    currentArr.forEach((doc: { id: number; status: any; statusId: any }) => {
      if (doc.id === id) {
        doc.status = value.poeDocStatusName;
        doc.statusId = value.poeDocStatusId;
      }
    });
    this.formPOESurvey.controls['poeDocs'].setValue(currentArr);
  }

  getSurveysForEngagement() {
    this.osmEdit.getEngagementSurveys(this.engagementId).subscribe(response => {
      this.engagementSurveys = response;
      if (
        this.engagementSurveys.find(survey => survey.surveyType == 'Customer')
      ) {
        this.osmEdit
          .getInvoiceRejectionReasonDropDown(DocumentsType.CustomerPOESurvey)
          .subscribe(result => {
            const reasons = {
              documentType: result[0].documentsType,
              reason: result
            };
            this.customerPOESurveyRejectionReasons = reasons;
          });
      }
      const surveyRejectedReasons = this.engagementSurveys.map(
        survey => survey.documentRejectionReasons
      );
      if (surveyRejectedReasons != null && surveyRejectedReasons.length > 0) {
        const reasons = surveyRejectedReasons[0].map(reason => {
          return {
            documentType: reason['documentType'],
            reason: reason['reason'],
            reasonID: reason['reasonId']
          };
        });
        this.formPOESurvey.controls[
          'customerPOESurveyRejectionReasonsCtrl'
        ].setValue(reasons);
        this.customerSurveyRejectionReason = reasons
          .map(s => s.reason)
          .join(', ');
      }
    });
  }

  getPOESurveyStatus() {
    return this.osmEdit.getPoeSurveyStatusDropDown();
  }

  getPoeDocumentStatus() {
    return this.osmEdit.getPoeDocStatusDropDown();
  }

  getPoeInvoiceStatusDropDown() {
    return this.osmEdit.getPoeInvoiceStatusDropDown();
  }

  getPoeStatus() {
    this.osmEdit.getPoeStatusDropDown().subscribe(PTList => {
      this.poeStatus = PTList;
    });
  }

  downloadPOE(downloadPOE: PoeNominationDocument) {
    this.downloadSpin[0] = true;
    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: this.engagementId,
      fileName: downloadPOE.fileName
    };

    this.ds
      .getFileSasUrl(downloadAcknowledgementInputModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  getSurveyResponseFile(eng: number) {
    this.osmEdit
      .getSurveyResponseFile(eng, 'Customer')
      .subscribe(downloadReport => {
        this.customer = downloadReport;
      });
  }

  cusSurveyResponseDownload(fille: string) {
    if (fille === 'Customer') {
      if (this.customer.length === 0) {
        this.msgsPoeSurvey = [];
        this.msgsPoeSurvey.push({
          severity: 'error',
          detail: 'Customer Survey Response File is not available'
        } as any);
        return;
      } else {
        this.fileNamePartCust = this.customer[0].fileName || '';
      }
    } else {
      if (this.partner.length === 0) {
        this.msgsPoeSurvey = [];
        this.msgsPoeSurvey.push({
          severity: 'error',
          detail: 'Partner Survey Response File is not available'
        } as any);
        return;
      } else {
        this.fileNamePartCust = this.partner[0].fileName || '';
      }
    }

    const headers = new HttpHeaders();
    const downloadUrl =
      this.settingsServices.baseUrl +
      'api/PoeInformation/DownloadSurveyResponseFile/' +
      this.engagementId +
      '/' +
      fille +
      '/' +
      this.fileNamePartCust;

    this.http
      .get(downloadUrl, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(file, this.fileNamePartCust);
      });
  }

  previewInvoice(invoiceFile: PoeNominationDocument) {
    switch (invoiceFile.documentId) {
      case DocumentTypes.POEInvoice:
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.poeinvoice;
        break;
      case DocumentTypes.RequestForProposalDescription:
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.rfpDescription;
        break;
      case DocumentTypes.RequestForProposalAwardLetter:
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.rfpAward;
        break;
      case DocumentTypes.SOW:
        this.engagementPreviewInput.documentType = PreviewDocumentTypes.SOW;
        break;
      default:
        this.engagementPreviewInput.documentType =
          PreviewDocumentTypes.poedocument;
    }
    this.engagementPreviewInput.isPoePreview = this.isPoeInvoicePreview = false;
    this.engagementPreviewInput.engagementId = this.engagementId;
    this.engagementPreviewInput.previewFileIndex = 1;
    this.engagementPreviewInput.invoiceFile = invoiceFile;
    this.engagementPreviewInput.isCustomerAckApproval = false;
    this.engagementPreviewInput.documentTypeId = invoiceFile.documentId;
    this.canShowPreviewModel = true;
  }

  previewHistoryDocument(file: PoeNominationDocument) {
    this.engagementPreviewInput.isHistoryDocument = true;
    this.engagementPreviewInput.isPoePreview = false;
    this.engagementPreviewInput.engagementId = this.engagementId;
    this.engagementPreviewInput.previewFileIndex = 1;
    this.engagementPreviewInput.invoiceFile = file;
    this.engagementPreviewInput.isCustomerAckApproval = false;
    this.engagementPreviewInput.documentTypeId = file.documentId;

    const previewModel: UpdateCustomerAckDocument = {
      engagementId: this.engagementId,
      fileName: file.fileName
    };

    this.ds.getFileSasUrl(previewModel).subscribe(downloadFileSasUrl => {
      if (this.engagementPreviewInput.invoiceFile) {
        this.engagementPreviewInput.invoiceFile.poeDocFilePath =
          downloadFileSasUrl;
      }
      this.canShowPreviewModel = true;
    });
  }

  checkPoeDocumentType(documentTypeId: number) {
    return DocumentTypesString[documentTypeId];
  }

  isRFPDoc(documentTypeId: number) {
    return documentTypeId == DocumentTypes.RequestForProposalAwardLetter ||
      documentTypeId == DocumentTypes.RequestForProposalDescription
      ? true
      : false;
  }

  reviewPoeInvoice(event?: boolean) {
    if (event) {
      this.formPOESurvey.controls['poeInvoicestatus'].setValue({
        poeDocStatusId: 5,
        poeDocStatusName: 'Completed'
      });
    } else {
      this.formPOESurvey.controls['poeInvoicestatus'].setValue({
        poeDocStatusId: 4,
        poeDocStatusName: 'Rejected'
      });
    }
    this.refreshNotes();
    this.getPoeDocumentsForEngagement();
  }
  getNotesList(reqId: number): void {
    this.osmEdit.getNotes(reqId).subscribe(noteslistService => {
      this.notes = noteslistService;
    });
  }
  refreshNotes() {
    this.getNotesList(this.engagementId);
  }

  getReasons(reasons: DocumentDeclineReason[]) {
    return reasons ? reasons.map(s => s.reason).join(', ') : '';
  }

  canShowInvoicePreview(filePath: string) {
    if (!filePath) return true;
    const fileExtension = filePath
      ?.split('/')[5]
      ?.split('?')[0]
      ?.trim()
      ?.split('.')
      ?.pop()
      ?.toLowerCase();

    const extensions: string[] = [
      'pdf',
      'jpeg',
      'png',
      'jpg',
      'bmp',
      'gif',
      'doc',
      'docx',
      'ppt',
      'pptx'
    ];
    return extensions.some(v => v === fileExtension);
  }

  cusSurveyResponse() {
    this.isCusSurveyResponse = !this.isCusSurveyResponse;
  }

  editPoeSurveyCancel() {
    this.isReadonlyPOESurvey = true;
    this.msgsPoeSurvey = [];
    this.btnNavPoeSurvey = !this.btnNavPoeSurvey;
    this.formPOESurvey.disable();
    this.cancelPoeSurvey();
  }

  editPoeSurvey() {
    this.isReadonlyPOESurvey = false;
    this.btnNavPoeSurvey = true;
    this.formPOESurvey.enable();
  }

  onSubmitPOESurvey() {
    let isValidForm = true;
    this.updatePoeInformationRequest = new UpdatePOEInformationRequest();
    this.updatePoeInformationRequest.requestDetailId = this.engagementId;
    const datePipe = new DatePipe('en-US');

    this.updatePoeInformationRequest.poeStatusId =
      this.formPOESurvey.controls['PoeStatus1'].value.poeStatusId;
    this.updatePoeInformationRequest.poeStatusName =
      this.formPOESurvey.controls['PoeStatus1'].value.poeStatusName;

    const pOECompletionDate = datePipe.transform(
      this.formPOESurvey.controls['pOECompletionDate'].value,
      'MM/dd/yyyy'
    );

    this.updatePoeInformationRequest.poecompletionDate =
      pOECompletionDate || undefined;

    const customerSurveyType = 'Customer';
    const surveyModel = this.engagementSurveys.find(
      s => s.surveyType == customerSurveyType
    );
    if (surveyModel) {
      if (this.updatePoeInformationRequest.customerSurvey) {
        this.updatePoeInformationRequest.customerSurvey.type =
          customerSurveyType;
      }
    }

    if (this.updatePoeInformationRequest.customerSurvey) {
      this.updatePoeInformationRequest.customerSurvey.requestDetailId =
        this.engagementId;
      this.updatePoeInformationRequest.customerSurvey.surveyStatusId =
        this.formPOESurvey.controls[
          'customerPOESurveyStatus'
        ].value.poeSurveyStatusId;
      this.updatePoeInformationRequest.customerSurvey.surveyStatusName =
        this.formPOESurvey.controls[
          'customerPOESurveyStatus'
        ].value.poeSurveyStatusName;
    }

    this.updatePoeInformationRequest.documents =
      this.poeNominationDocuments.poeDocuments.map(document => {
        const control = this.getPoeDocumentStatusFormControl(
          document.documentId
        );
        const x = control ? control.value : {};
        return new UpdatePOEInformationRequestDocument({
          documentStatusId:
            x.poeDocStatusId === undefined ? 6 : x.poeDocStatusId,
          documentId: document.oFactNominationPOEdocumentsId,
          documentTypeId: document.documentId,
          documentStatusName:
            x.poeDocStatusName === undefined ? 'Missing' : x.poeDocStatusName
        });
      });

    const rejectedDocuments = this.updatePoeInformationRequest.documents.filter(
      doc => doc.documentStatusName == 'Rejected'
    );

    this.updatePoeInformationRequest.documentsRejectionInfo =
      rejectedDocuments.map(document => {
        if (this.hasValidRejectionReasons(document.documentTypeId as any)) {
          let selectedReasons = [];

          if (document.documentTypeId) {
            selectedReasons = this.getPoeDocumentRejectReasonFormControl(
              document.documentTypeId
            )?.value;
          }

          if (selectedReasons.length > 0) {
            const documentReviewInfo: DocumentReviewModel = {
              requestDetailId: this.engagementId,
              isApprove: false,
              documentType: document.documentTypeId || -1,
              reasons: [],
              customerSurveyId: 0,
              oFactNominationPOEdocumentsId: document.documentId,
              filePath:
                this.poeNominationDocuments.poeDocuments.find(
                  doc =>
                    doc.oFactNominationPOEdocumentsId == document.documentId
                )?.filePath || ''
            };

            selectedReasons.forEach((reason: any) => {
              documentReviewInfo.reasons.push(reason);
            });

            return documentReviewInfo;
          } else {
            isValidForm = false;
          }
        }
        return document;
      }) as any;

    if (
      this.updatePoeInformationRequest.customerSurvey?.surveyStatusName ==
      'Rejected'
    ) {
      const surveyRejectReason =
        this.formPOESurvey.controls['customerPOESurveyRejectionReasonsCtrl']
          .value;
      if (surveyRejectReason.length > 0) {
        const surveyReviewInfo: DocumentReviewModel = {
          requestDetailId: this.engagementId,
          isApprove: false,
          documentType: DocumentsType.CustomerPOESurvey,
          reasons: [],
          customerSurveyId: this.customerSurveryId,
          oFactNominationPOEdocumentsId: 0,
          filePath: this.customerSurveyFilePath
        };

        surveyRejectReason.forEach((reason: any) => {
          surveyReviewInfo.reasons.push(reason);
        });

        if (this.updatePoeInformationRequest.documentsRejectionInfo) {
          this.updatePoeInformationRequest.documentsRejectionInfo.push(
            surveyReviewInfo
          );
        } else {
          this.updatePoeInformationRequest.documentsRejectionInfo = [
            surveyReviewInfo
          ];
        }
      } else {
        isValidForm = false;
      }
    }

    const pOEDocumentSubmittedDate = datePipe.transform(
      this.formPOESurvey.controls['poeDocumentSubmittedDate'].value,
      'MM/dd/yyyy'
    );
    this.updatePoeInformationRequest.pOEDocumentSubmittedDate =
      pOEDocumentSubmittedDate || undefined;

    const customerPOESurveyDate = datePipe.transform(
      this.formPOESurvey.controls['customerPOESurveyDate'].value,
      'MM/dd/yyyy'
    );

    if (this.updatePoeInformationRequest.customerSurvey) {
      this.updatePoeInformationRequest.customerSurvey.surveyDate =
        customerPOESurveyDate || undefined;
    }

    this.uname = this.settingsServices.AliasName || '';
    this.updatePoeInformationRequest.lastUserAlias = this.uname;

    if (isValidForm) {
      this.osmEdit
        .updatePOEInformation(this.updatePoeInformationRequest)
        .subscribe(
          messageResponse => {
            this.apires = messageResponse;
            if (this.apires.success === true) {
              this.refreshPartnerInput.emit('');
              this.formEngagementDetails.controls['enagementType'].setValue(
                this.formPOEInformation.controls['workshopTypeCompleted'].value
                  .engagementType
              );
              this.poeNominationRequiredDocuments.map(
                doc => (doc['reasons'] = null)
              );
              this.updatePoeInformationRequest.documentsRejectionInfo?.forEach(
                updatedDocument => {
                  if (
                    updatedDocument &&
                    updatedDocument.documentType !=
                      DocumentsType.CustomerPOESurvey
                  ) {
                    const index = this.poeNominationRequiredDocuments.findIndex(
                      doc => doc.documentId == updatedDocument.documentType
                    );
                    this.poeNominationRequiredDocuments[index]['reasons'] =
                      updatedDocument.reasons;
                  }
                }
              );

              const rejectedSurvey =
                this.updatePoeInformationRequest.documentsRejectionInfo?.find(
                  doc => doc.documentType == DocumentsType.CustomerPOESurvey
                );

              if (rejectedSurvey) {
                this.customerSurveyRejectionReason = rejectedSurvey.reasons
                  .map(s => s.reason)
                  .join(', ');
              }

              const notRejectedDocs =
                this.updatePoeInformationRequest?.documents?.filter(
                  doc => doc.documentStatusName != 'Rejected'
                );

              notRejectedDocs?.map(doc => {
                const rejectionReasonControl =
                  this.getPoeDocumentRejectReasonFormControl(
                    doc.documentTypeId as number
                  );

                if (rejectionReasonControl) {
                  rejectionReasonControl.setValue(null);
                }
              });

              if (
                this.updatePoeInformationRequest?.customerSurvey
                  ?.surveyStatusName != 'Rejected'
              ) {
                this.formPOESurvey.controls[
                  'customerPOESurveyRejectionReasonsCtrl'
                ].setValue(null);
              }

              this.msgsPoeSurvey = [];
              this.msgsPoeSurvey.push({
                severity: 'success',
                detail: 'POE status saved successfully.'
              } as any);
              this.btnNavPoeSurvey = false;
              this.formPOESurvey.disable();
            }
            if (this.apires.success === false) {
              this.msgsPoeSurvey = [];
              this.msgsPoeSurvey.push({
                severity: 'error',
                detail: this.apires.message
              } as any);
            }
          },
          error => {
            this.msgsPoeSurvey = [];
            let errors: string[] = [];
            if (error.status === 400) {
              errors = this.commonService.getBadRequestErrors(error);
              for (const msg of errors) {
                this.msgsPoeSurvey.push({
                  severity: 'warn',
                  detail: msg
                } as any);
              }
            } else {
              this.msgsPoeSurvey.push({
                severity: 'warn',
                detail:
                  'Sorry an Error Occured while Adding PoeInformation Details'
              } as any);
            }
          }
        );
    } else {
      this.msgsPoeSurvey = [];
      this.msgsPoeSurvey.push({
        severity: 'warn',
        detail: 'Please choose reasons for rejected documents/survey.'
      } as any);
    }
  }

  hasValidRejectionReasons(documentType: DocumentTypes) {
    switch (documentType) {
      case DocumentTypes.POEDocument:
        return this.poeDocumentRejectionReasons ? true : false;
      case DocumentTypes.POEInvoice:
        return this.poeInvoiceRejectionReasons ? true : false;
      case DocumentTypes.RequestForProposalAwardLetter:
        return this.rfpAwardLetterRejectionReasons ? true : false;
      case DocumentTypes.RequestForProposalDescription:
        return this.rfpDescriptionRejectionReasons ? true : false;
      case DocumentTypes.SOW:
        return this.sowDocRejectionReasons ? true : false;
    }
    return false;
  }

  cancelPoeSurvey() {
    this.msgsPoeSurvey = [];
  }

  previewCustomerSurvey(engagementId: number) {
    this.engagementPreviewInput = {
      engagementId: engagementId,
      documentType: PreviewDocumentTypes.customerSurvey,
      engagementIdList: [engagementId],
      previewFileIndex: 0,
      isPoePreview: false,
      isCustomerAckApproval: false,
      customerSurveyResponse: [],
      documentTypeId: 0,
      isHistoryDocument: false
    };

    this.canShowPreviewModel = true;
  }

  previewPartnerSurvey(engagementId: number) {
    this.engagementPreviewInput = {
      engagementId: engagementId,
      documentType: PreviewDocumentTypes.partnerSurvey,
      engagementIdList: [engagementId],
      previewFileIndex: 0,
      isPoePreview: false,
      isCustomerAckApproval: false,
      customerSurveyResponse: [],
      documentTypeId: 0,
      isHistoryDocument: false
    };

    this.canShowPreviewModel = true;
  }

  closePreview() {
    this.closePreviewModal.emit('');
    this.canShowPreviewModel = false;
    this.isPoeInvoicePreview = false;
  }

  reviewPoeDocument(event?: boolean) {
    if (event) {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 5,
        poeDocStatusName: 'Completed'
      });
    } else {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 4,
        poeDocStatusName: 'Rejected'
      });
    }
    this.refreshNotes();
    this.getPoeDocumentsForEngagement();
  }

  private filterRequiredDocuments(
    documents: PoeNominationDocuments
  ): PoeNominationDocument[] {
    return documents.poeDocuments.filter(doc => doc.status != 'Missing');
  }

  getStatusValueForDocument(event: { documentTypeId: any }) {
    const value = this.formPOESurvey.controls['poeDocs'].value.find(
      (s: { documentTypeId: any }) => (s.documentTypeId = event.documentTypeId)
    ).status;
    return value;
  }

  get DocumentTypesValue(): typeof DocumentTypes {
    return DocumentTypes;
  }

  onPoeDocumentUploadClick(documentType: number) {
    this.docType = documentType;
    this.loadUploadDialog = true;
  }

  cancelUploadDocument() {
    this.loadUploadDialog = false;
    this.clearHtmlFileInput();
    this.storeCustAckFile = {};
    this.filesUpload = [];
  }

  fileuploding(formData: any) {
    this.uploadUrl =
      this.settingsServices.baseUrl +
      'api/EngagementDetails/InsertMultipleFile/' +
      this.engagementId;
    this.http
      .post<CustomerAcknowledgement[]>(this.uploadUrl, formData)
      .subscribe(
        (efRes: any) => {
          this.storeCustAckFile = efRes;
          const finalFile = this.filesUpload.find(
            (a: { fileName: any }) => a.fileName === efRes.fileName
          );
          const idx = this.filesUpload.indexOf(finalFile);
          this.fileUploadSpinners[idx] = false;
          if (++this.loadingCount === this.filesUpload.length) {
            this.transactionSpin = false;
          }
          this.getPoeDocumentsForEngagement();
        },
        error => {
          this.umsgs = [];
          if (error.status === 500) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 502) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while uploading a file'
            });
            this.filesUpload = [];
            this.fileUploadSpinners = [];
            this.transactionSpin = false;
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
        }
      );
  }
  submitCustomerAckFile() {
    if (this.storeCustAckFile === undefined || this.storeCustAckFile === null) {
      this.umsgs = [];
      const noFileError =
        this.docType === DocumentsType.POEInvoice ||
        this.docType === DocumentsType.POEDocument
          ? 'Upload POE Document to submit'
          : 'Upload Customer Acknowledgement file to Submit';
      this.umsgs.push({ severity: 'error', detail: noFileError });
      setTimeout(() => {
        this.umsgs = [];
      }, 4000);
    } else {
      if (
        this.docType === DocumentsType.POEInvoice ||
        this.docType === DocumentsType.POEDocument ||
        this.docType === DocumentsType.RequestForProposalAwardLetter ||
        this.docType === DocumentsType.RequestForProposalDescription
      ) {
        this.submitUploadedPOEDocuments();
      } else {
        this.submitAck = {
          engagementId: this.engagementId,
          fileName: this.storeCustAckFile.fileName,
          fileURL: this.storeCustAckFile.url
        };

        this.osmEdit.submitCustomerAck(this.submitAck).subscribe(
          messageResponse => {
            this.apires = messageResponse;
            if (this.apires.success === true) {
              this.storeCustAckFile = {};
              this.refreshPartnerInput.emit('');
              this.umsgs = [];
              this.umsgs.push({
                severity: 'success',
                detail: this.apires.message
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 4000);
            }
            if (this.apires.success === false) {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: this.apires.errorMessages
                  ? this.apires.errorMessages[0]
                  : 'An error occurred'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 4000);
            }
          },
          error => {
            if (error.status === 500) {
              this.umsgs = [];
              this.umsgs.push({ severity: 'error', detail: error.error });
              setTimeout(() => {
                this.umsgs = [];
              }, 2000);
            } else {
              this.umsgs.push({
                severity: 'warn',
                detail: 'Sorry an Error Occured while Changing Engagement'
              });
            }
          }
        );
      }
    }
  }
  formatBytes(bytes: number, decimals: number) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  submitUploadedPOEDocuments() {
    const poeDocument: SpecialInvestmentPoeDocument = {
      engagementId: this.engagementId,
      fileName: this.storeCustAckFile.fileName || '',
      FileURL: this.storeCustAckFile.url || '',
      documentType: this.docType,
      documentTypeId: this.docType,
      Status: 'Submitted',
      filePath: ''
    };

    this.osmEdit
      .submitSpecialInvestmentUploadedPOEDocuments(poeDocument)
      .subscribe(
        () => {
          this.cancelUploadDocument();
          this.reloadEngagementDetails();
        },
        error => {
          if (error.status === 500) {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'error',
              detail: error.error.errorInfo
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 2000);
          } else {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured'
            });
          }
        }
      );
  }

  private clearHtmlFileInput() {
    this.myfileInput.nativeElement.value = '';
  }

  reloadEngagementDetails() {
    this.getPoeDocumentsForEngagement();
    this.getDetails(this.engagementId);
  }

  uploadFile(event: any) {
    const files = event.target?.files as string | any[];
    if (
      this.docType === DocumentsType.POEInvoice ||
      this.docType === DocumentsType.POEDocument ||
      this.docType === DocumentsType.RequestForProposalAwardLetter ||
      this.docType === DocumentsType.RequestForProposalDescription
    ) {
      this.uploadPOEDocumentToBlob(files);
    } else {
      for (const fileUpload of files) {
        const ext = fileUpload.name.substring(
          fileUpload.name.lastIndexOf('.') + 1
        );
        if (
          ext.toLowerCase() === 'pdf' ||
          ext.toLowerCase() === 'jpeg' ||
          ext.toLowerCase() === 'png' ||
          ext.toLowerCase() === 'jpg' ||
          ext.toLowerCase() === 'bmp' ||
          ext.toLowerCase() === 'gif' ||
          ext.toLowerCase() === 'doc' ||
          ext.toLowerCase() === 'docx' ||
          ext.toLowerCase() === 'ppt' ||
          ext.toLowerCase() === 'pptx'
        ) {
          if (fileUpload.size > 10485760) {
            this.umsgs.push({
              severity: 'error',
              detail: fileUpload.name + 'files is greater than 10 Mb'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 6000);
          } else {
            const formData = new FormData();
            formData.append('file', fileUpload, fileUpload.name);
            const newFile = {
              fileName: fileUpload.name,
              size: fileUpload.size
            };
            if (
              this.filesUpload.find(
                (a: { fileName: any }) => a.fileName === newFile.fileName
              ) === undefined
            ) {
              if (
                this.filesUpload.length === 0 ||
                this.filesUpload.length !== 1
              ) {
                this.filesUpload.push(newFile);
                this.fileUploadSpinners.push(true);
                this.fileuploding(formData);
                this.transactionSpin = true;
              } else {
                this.umsgs = [];
                this.umsgs.push({
                  severity: 'error',
                  detail: 'Possible upload only one file in list'
                });
                setTimeout(() => {
                  this.umsgs = [];
                }, 6000);
              }
            } else {
              this.umsgs = [];
              this.umsgs.push({
                severity: 'error',
                detail: fileUpload.name + ' file already exits in list'
              });
              setTimeout(() => {
                this.umsgs = [];
              }, 6000);
            }
          }
        } else {
          this.umsgs.push({
            severity: 'error',
            detail: 'doc, pdf, image or pptx type files are Acceptable'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 6000);
        }
      }
      this.myfileInput.nativeElement.value = '';
    }
  }

  uploadPOEDocumentToBlob(event: string | any[]) {
    if (event.length > this.poeDocMaximumFiles) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail: 'Multiple files are not allowed to upload'
      });
      this.clearHtmlFileInput();
    } else {
      const fileUpload = event[0] as File;
      if (this.isValidFileSize(fileUpload)) {
        const formData = new FormData();
        formData.append('file', fileUpload, fileUpload.name);
        const newFile = {
          fileName: fileUpload.name,
          size: fileUpload.size
        } as PoeDocument;

        formData.append('documentType', this.docType.toString());
        if (
          this.filesUpload.find(
            (a: { fileName: string }) => a.fileName === newFile.fileName
          ) === undefined
        ) {
          if (this.filesUpload.length === 0 || this.filesUpload.length !== 1) {
            this.filesUpload.push(newFile);
            this.fileUploadSpinners.push(true);
            this.uploadPOEDocToBlob(formData);
            this.transactionSpin = true;
          } else {
            this.umsgs = [];
            this.umsgs.push({
              severity: 'error',
              detail: 'Possible upload only one file in list'
            });
            setTimeout(() => {
              this.umsgs = [];
            }, 6000);
          }
        } else {
          this.umsgs = [];
          this.umsgs.push({
            severity: 'error',
            detail: fileUpload.name + ' file already exits in list'
          });
          setTimeout(() => {
            this.umsgs = [];
          }, 6000);
        }
      }
    }
  }

  uploadPOEDocToBlob(formData: any) {
    this.osmEdit.uploadPOEDocToBlob(formData, this.engagementId).subscribe(
      (efRes: any) => {
        this.storeCustAckFile = efRes;
        const finalFile = this.filesUpload.find(
          (a: { fileName: any }) => a.fileName === efRes.fileName
        );
        const idx = this.filesUpload.indexOf(finalFile);
        this.fileUploadSpinners[idx] = false;
        if (++this.loadingCount === this.filesUpload.length) {
          this.transactionSpin = false;
        }
      },
      error => {
        this.umsgs = [];
        if (error.status === 500) {
          this.umsgs.push({ severity: 'error', detail: error.statusText });
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        } else if (error.status === 502) {
          this.umsgs.push({ severity: 'error', detail: error.statusText });
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        } else {
          this.umsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while uploading a file'
          });
          this.filesUpload = [];
          this.fileUploadSpinners = [];
          this.transactionSpin = false;
          setTimeout(() => {
            this.umsgs = [];
          }, 4000);
        }
      }
    );
  }
  private isValidFileSize(file: File): boolean {
    const fileSizeinMB = file.size / (1024 * 1000);
    const size = Math.round(fileSizeinMB * 100) / 100;

    if (size > 10) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail:
          'Error (File Size): ' +
          file.name +
          ': exceed file size limit of 10 MB '
      });
      setTimeout(() => {
        this.umsgs = [];
      }, 6000);
      this.clearHtmlFileInput();
      return false;
    }

    return true;
  }

  IsRFPWorkshop() {
    if (this.deliveryName == 'Security Request for Proposal') {
      return true;
    } else {
      return false;
    }
  }

  previewFile(index: any) {
    this.engagementPreviewInput = {
      engagementId: this.engagementId,
      previewFileIndex: index,
      isPoePreview: false,
      isCustomerAckApproval: false,
      documentType: '',
      customerSurveyResponse: [],
      documentTypeId: 0,
      engagementIdList: [],
      isHistoryDocument: false
    };

    this.canShowPreviewModel = true;
  }

  canShowPreviewButton(customerAcknowledgement: CustomerAcknowledgement) {
    const fileName = customerAcknowledgement.fileName;
    const extensions: string[] = [
      '.pdf',
      '.jpeg',
      '.png',
      '.jpg',
      '.bmp',
      '.gif'
    ];
    return extensions.some(v => fileName?.toLowerCase().endsWith(v));
  }

  downloadFile(index: string | number) {
    this.downloadSpin[index] = true;
    const downloadAcknowledgementInputModel = {
      engagementId: this.engagementId,
      fileName: this.customerAck[index].fileName,
      documentType: this.customerAcknowledgement
    };

    this.ds
      .getFileSasUrl(downloadAcknowledgementInputModel)
      .subscribe(downloadFileSasUrl => {
        setTimeout(() => {
          const custAck = this.customerAck.find(
            itm => itm.fileName === this.customerAck[index].fileName
          );
          const idx = custAck ? this.customerAck.indexOf(custAck) : -1;
          this.downloadSpin[idx] = false;
        }, 5000);
        window.location.href = downloadFileSasUrl;
      });
  }

  deleteAttachment(index: number) {
    const a = this.customerAck.splice(index, 1);
    this.downloadSpin.splice(index, 1);
    if (this.filesUpload.length > 0) {
      for (let i = 0; i < this.filesUpload.length; i++) {
        if (this.filesUpload[i].fileName === a[0].fileName) {
          this.filesUpload.splice(i, 1);
          this.fileUploadSpinners.splice(i, 1);
          --this.loadingCount;
        }
      }
    }
    if (a[0].fileName) {
      this.osmEdit
        .deleteCustomerAcknowledgementFile(this.engagementId, a[0].fileName)
        .subscribe(() => {
          this.getCustomerAckFile(this.engagementId);
        });
    }
  }

  getCustomerAckFile(id: number): void {
    this.osmEdit.getCustomerAcknowledgementFile(id).subscribe(imglist => {
      this.customerAck = imglist;
      this.downloadSpin = this.customerAck.map(() => false);
    });
  }

  get fileUploadHeader(): string {
    if (this.docType === DocumentsType.CustomerAcknowledgement) {
      return 'Upload Customer Acknowledgement';
    } else if (this.docType === DocumentsType.POEInvoice) {
      return 'Upload POE Invoice';
    } else if (this.docType === DocumentsType.POEDocument) {
      return 'Upload Findings and Recommendation';
    } else if (this.docType === DocumentsType.RequestForProposalAwardLetter) {
      return 'Upload RFP Award Letter';
    } else if (this.docType === DocumentsType.RequestForProposalDescription) {
      return 'Upload RFP Description';
    }
    return '';
  }

  get showUploadedFiles() {
    return (
      this.docType !== DocumentsType.POEInvoice &&
      this.docType !== DocumentsType.POEDocument &&
      this.docType !== DocumentsType.RequestForProposalAwardLetter &&
      this.docType !== DocumentsType.RequestForProposalDescription
    );
  }
}
